import { render, staticRenderFns } from "./IA1.vue?vue&type=template&id=30c0c4e8&"
import script from "./IA1.vue?vue&type=script&lang=js&"
export * from "./IA1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports